<div class="heading">{{ item()?.header ?? 'WALLET' }}</div>
<div class="cont">
  <div class="status-wrap">
    <i [ngClass]="transactionStatus() !== TranStatus.FAILED ? 'fi-check-circle success' : 'fi-x-circle fail'"></i>
    <div class="title">{{ title() }}</div>
    <div class="amount">
      {{ amount() | currencyValue: currency() }} {{ currency() }}
      <img class="currency-icon" [src]="currency() | currencyIcon" />
    </div>
    <div class="desc">{{ content() }}</div>
  </div>

  @if (transactionStatus() !== TranStatus.TIMEOUT_ERROR && item()?.data) {
    @switch (orderStatus()) {
      @case ('Pending') {
        <ng-container [ngTemplateOutlet]="progressRender"></ng-container>
      }
      @default {
        <ng-container [ngTemplateOutlet]="defaultRender"></ng-container>
      }
    }
  }
</div>

<div class="action-buttons">
  <cs-button (buttonClick)="close()" label="Close" color="accent" size="large"></cs-button>
  @if (transactionStatus() !== TranStatus.TIMEOUT_ERROR) {
    <cs-button
      (buttonClick)="jumpToTransactions()"
      label="Go to Transactions"
      color="secondary"
      size="large"
    ></cs-button>
  }
</div>

<ng-template #progressRender>
  <div>
    <div class="detail-wrap">
      <div class="progress-item">
        @if (transactionStatus() >= TranStatus.TRANSACTION_SENT) {
          <i class="fi-check-circle"></i>
        } @else {
          <div class="circle-loader"></div>
        }
        Transaction sent
      </div>
      <div class="progress-item">
        @if (transactionStatus() >= TranStatus.VERIFYING) {
          <i class="fi-check-circle"></i>
        } @else {
          <div class="circle-loader"></div>
        }
        Verifying your deposit
      </div>
      <div class="progress-item">
        @if (transactionStatus() >= TranStatus.CREDITED) {
          <i class="fi-check-circle"></i>
        } @else {
          <div class="circle-loader"></div>
        }
        Deposit credited
      </div>
      <div class="progress-bar">
        <div class="progress-inner" [style.width.%]="transactionProcess()"></div>
      </div>
    </div>
    <div class="desc" [style.marginTop]="'var(--xs)'">We will update your balance automatically once confirmed</div>
  </div>
</ng-template>

<ng-template #defaultRender>
  <div class="detail-wrap">
    <div class="list">
      <div class="item">
        <span>Status</span>
        <span
          [ngClass]="{
            mark: orderStatus() === 'Pending',
            total: orderStatus() === 'Successful',
            error: orderStatus() === 'Failed',
          }"
        >
          {{ orderStatus() }}
        </span>
      </div>

      <div class="item">
        <span>TXN Hash</span>
        <span class="copy-btn" (click)="copyTxnHash()">
          {{ txnHash() }}
          <i class="fi-clipboard"></i>
        </span>
      </div>
    </div>
  </div>
</ng-template>
